import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicSuperscalar = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Superscalar Architecture"
      videos={[
        "https://www.youtube.com/embed/9THB7oGNOMc",
        "https://www.youtube.com/embed/LD2aH3QjXkE",
        "https://www.youtube.com/embed/vZNwVOXID_o"
      ]}
      takeaways={[
        { text: "Understand all types of dependencies in superscalar architecture." },
        { text: "Learn the advantages and limitations of superscalar architectures." },
        { text: "Know the differences between superscalar architecture and pipelining." }
      ]}
      questions={[]} // Added empty array
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicSuperscalar;
